import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { EstadoSistema } from 'src/app/common/interfaces/estadosistema.interface';
import { SistemaService } from './sistema.service';
import { ToolsService } from '@services/varios/tools.service';
import { Router } from '@angular/router';
import { AUTH_ROUTE } from 'src/app/common/constants/routes.constants';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class EstadoSistemaTimerService implements OnDestroy {
  private subscription: Subscription | null = null;

  constructor(private readonly sistema: SistemaService,
              private readonly toolsService: ToolsService,
              private readonly router: Router
  ) {
    this.startTimer();
  }

  startTimer(): void {

    if ((this.subscription && !this.subscription.closed) || this.toolsService.userInRol(['ADMINISTRADOR'])) {
      return;
    }

    this.runTask();

    this.subscription = interval(2 * 60 * 1000).subscribe(() => {        
        this.runTask();
    });
  }

  async runTask(): Promise<void> {
    let estadoSistema:EstadoSistema = await this.sistema.getEstadoSistemaByIdSistema();    
    if (estadoSistema.estadoSistema === 'INACTIVO') {
        this.stopTimer();
        await this.toolsService.errorMensaje('Su sesión se cerrará!<br><br>' + estadoSistema.mensajeSistema, true);
        this.router.navigate([AUTH_ROUTE]);
    }
  }

  stopTimer(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }
}